module.exports = __webpack_public_path__ + "LuirenCosplayCraft.jpg?639c44ec39113ba6f13e77233f6dede5";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/LuirenCosplayCraft.jpg
// module id = 515
// module chunks = 0